import { render, staticRenderFns } from "./add-remove-button.vue?vue&type=template&id=04ee679c&"
import script from "./add-remove-button.vue?vue&type=script&lang=ts&"
export * from "./add-remove-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports